import styled from './BankSslBanner.module.scss'
import Icon from '../../assets/SslBanner.svg'

const BankSslBanner = () => {
  return (
    <div className={styled.wrapper}>
      <img src={Icon} alt='' />
      <span>
      Recibimos sus datos a través de un protocolo seguro con certificado SSL
      </span>
    </div>
  )
}

export default BankSslBanner